<script setup lang="ts">
import CoreIcon from '@core/core-icon.vue';
import {PropType} from "vue";
import {openLink} from "@tma.js/sdk-vue";
import PartLabel from "@parts/part-label.vue";
import isInTelegram from "@/utils/isInTelegram";

export interface OutsideLink {
  title: string,
  url: string,
  label?: string,
  target?: string,
}

const props = defineProps({
  list: {
    type: Array<OutsideLink>,
    default: () => []
  },
  icon: {
    type: Object as PropType<{ name: string, viewBox: string }>,
    default: () => {
    }
  },
  beforeNavigate: {
    type: Function as PropType<(item: OutsideLink) => Promise<void> | void>,
    default: () => () => true
  }
})

const handleClick = async (event: MouseEvent, item: OutsideLink) => {
  if (item.target) return;

  if (isInTelegram() && openLink.isAvailable()) {
    event.preventDefault();
  }

  await props.beforeNavigate(item);

  if (isInTelegram() && openLink.isAvailable()) {
    openLink(item.url, {tryInstantView: true});
  }
};
</script>

<template>
  <ul class="part-outside-links">
    <li
        v-for="(item, index) in list" :key="index"
        class="part-outside-links__item"
    >
      <a
          :href="item.url"
          :target="item?.target || '_blank'"
          @click="(e) => handleClick(e, item)"
          class="part-outside-links__item-link"
      >
				<span class="part-outside-links__item-title font-16-pro-regular">
          <part-label
              v-if="item.label"
              class="part-outside-links__item-label"
              pink
          >
            {{ item.label }}
          </part-label>
					{{ item.title }}
				</span>
        <span
            v-if="icon"
            class="part-outside-links__item-icon"
        >
					<core-icon v-bind="icon"/>
				</span>
      </a>
    </li>
  </ul>
</template>

<style lang="scss">
.part-outside-links {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  &__item {
    display: block;
  }

  &__item-link {
    display: flex;
    align-items: center;
    padding: 0.9rem 1.6rem;
    background-color: var(--color-panel);
	border: 1px solid var(--color-panel);
    border-radius: 1.6rem;
	transition: ease 0.12s;
	@include min-desktop {
		padding: 1.4rem 1.6rem;
		&:hover {
			background-color: rgba(var(--color-active-rgb), 0.10);
		}
	}
  }
  &__item-label {
	@include min-desktop {
		padding: 0.8rem;
		@include font-regular;
	}
  }
  &__item-title {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    flex-direction: row;
    gap: 1rem;
    min-width: 0;
  }

  &__item-icon {
    width: 3.2rem;
    height: 3.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    fill: var(--color-active);
    background: var(--color-white);
    border-radius: 50%;

	@include theme-dark {
		background-color: var(--color-panel);
	}

    svg {
      width: 1.8rem;
    }
  }
}
</style>
